"use client";
import SkillCard from "@/components/ui/Card/SkillCard";
import { SKILLS } from "@/contants";
import { cn } from "@/libs/utils";
import { motion } from "framer-motion";
import { useState } from "react";

export default function Skill() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <motion.div
      initial={{ opacity: 0, y: 200 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      viewport={{ once: true }}
      className="w-full h-full mt-10 relative"
    >
      <div className="grid grid-cols-4 lg:grid-cols-6 gap-3 relative z-10">
        {SKILLS.map((field, index) => (
          <motion.div
            className={cn("col-span-1 row-span-1", !index ? "lg:-order-1" : "")}
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 1,
              delay: (index + 2) / 10,
              ease: "easeOut",
            }}
            viewport={{ once: true }}
            key={field.name}
          >
            <SkillCard
              {...field}
              index={index}
              hovered={hovered}
              setHovered={setHovered}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
